import React, { useState, useContext, useMemo, useEffect } from 'react';
import { Layout, Menu, Typography } from 'antd';
import DalleConfig from './DalleConfig';
import OpenAIConfig from './OpenAIConfig';
import GeminiConfig from './GeminiAIConfig';
import ClaudeAIConfig from './ClaudeAIConfig';
import DeepseekConfig from './DeepseekConfig';
import UsersTokenConfig from './UsersTokenConfig';
import { ThemeContext } from "../../contexts/themeConfig";
import LinkedInUserConfig from './LinkedInUserConfig';
import './Configuration.css';
import { AdminDefinedApps } from '../../component/AddApiEndpoint/AdminDefinedApps';
import FluxConfig from './FluxConfig';
import { useNavigate } from 'react-router-dom';
import useAssistantPage from '../../Hooks/useAssistantPage';
import AssistantSettings from '../../component/Assistant/AssistantSettings';

const { Sider, Content } = Layout;
const { Text } = Typography;

const Configration = () => {
  const [selectedMenu, setSelectedMenu] = useState('openai');
  const { theme } = useContext(ThemeContext);

  useEffect(()=>{
    handleFetchTeams();
  },[]);

  const {
    teamList,
    loader,
    handleFetchTeams,
    updateLoader
  } = useAssistantPage();

  const menuItems = useMemo(() => [
    { key: 'openai', label: 'OpenAI Settings', component: OpenAIConfig },
    { key: 'dalle', label: 'Dall-E Settings', component: DalleConfig },
    { key: 'flux', label: 'FLUX Settings', component: FluxConfig },
    { key: 'gemini', label: 'Gemini Settings', component: GeminiConfig },
    { key: 'claude', label: 'Claude Settings', component: ClaudeAIConfig },
    { key: 'deepseek', label: 'DeepSeek Settings', component: DeepseekConfig },
    { key: 'linkedin', label: 'LinkedIn Settings', component: LinkedInUserConfig },
    { key: 'maxtoken', label: 'Max Token Configuration', component: UsersTokenConfig },
    { key: 'addapis', label: 'Apps and Integrations', component: AdminDefinedApps },
    { key: 'Organization', label: 'Agent Settings', component: () => <AssistantSettings data={{ loader, teamList, handleFetchTeams, updateLoader }} /> }
  ], [handleFetchTeams, loader, teamList, updateLoader]);

  const selectedComponent = useMemo(() => {
    const item = menuItems.find(item => item.key === selectedMenu);
    return item ? <item.component /> : null;
  }, [selectedMenu, menuItems]);

  const siderStyle = useMemo(() => ({
    backgroundColor: theme === "light" ? "#fff" : "#000",
    padding: "15px"
  }), [theme]);

  const menuItemsWithWrappedLabels = menuItems.map(item => ({
    ...item,
    label: (
      <Text
        style={{ maxWidth: '100%', display: 'inline-block' }}
      >
        {item.label}
      </Text>
    )
  }));

  return (
    <Layout className="parentLayout">
      <Sider width={256} style={siderStyle}>
        <div className="configuration-sidemenu">
          <Menu
            onClick={({ key }) => setSelectedMenu(key)}
            defaultSelectedKeys={['openai']}
            mode="inline"
            items={menuItemsWithWrappedLabels}
          />
        </div>
      </Sider>
      <Layout style={{ overflowY: "auto", backgroundColor: "var(--main-bg-color)" }}>
        <Content className="tableContent">
          {selectedComponent}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Configration;;